import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { styled } from "@mui/material";

import StoreAddressAutocompleteInput, {
  AutocompleteAddress,
} from "../CheckoutAddressAutocompleteInput";
import { InputContainer } from "@/components/Checkout/components/InputContainer";
import { CheckoutInputV2 } from "@/components/Checkout/components/CheckoutInputV2";
import { ShippingAddress } from "@/components/Checkout/types";

const Container = styled("div")(({ theme }) => ({
  transition: "all 0.3s ease-in-out",

  display: "flex",
  flexDirection: "column",
  gap: 16,
  ".title": {
    fontSize: 20,
    fontWeight: 600,

    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
}));

interface AddressFormProps {
  value: Partial<ShippingAddress>;
  onChange: (address: Partial<ShippingAddress>) => void;
  disabled?: boolean;
}

const AddressForm = ({
  value,
  onChange,
  disabled = false,
}: AddressFormProps) => {
  // const fullAddressString = buildAddressString(value);

  const handleChange = (field: keyof ShippingAddress, newValue: string) => {
    onChange({
      ...value,
      [field]: newValue,
    });
  };

  return (
    <Container>
      <InputContainer>
        <CheckoutInputV2
          label={"First Name"}
          value={value.firstName || ""}
          onChange={(e) => handleChange("firstName", e.target.value)}
          disabled={disabled}
        />
        <CheckoutInputV2
          label={"Last Name"}
          value={value.lastName || ""}
          onChange={(e) => handleChange("lastName", e.target.value)}
          disabled={disabled}
        />
      </InputContainer>
      <InputContainer>
        <StoreAddressAutocompleteInput
          searchTerm={value.address1 || ""}
          selectAddressCallback={(address: AutocompleteAddress) => {
            onChange({
              ...value,
              address1: address?.line1 || "",
              city: address?.city || "",
              state: address?.state || "",
              zipCode: address?.zip || "",
            });
          }}
          renderInput={(param: any) => (
            <CheckoutInputV2
              placeholder="Begin typing to search"
              label={"Street address"}
              value={value.address1}
              onChange={(e) => {
                return handleChange("address1", e.target.value);
              }}
              disabled={disabled}
              {...param}
              InputProps={{
                ...param.InputProps,
              }}
              inputProps={{
                ...param.inputProps,
                value: value.address1,
              }}
            />
          )}
        />
      </InputContainer>
      <InputContainer>
        <CheckoutInputV2
          label={"Suite, Apartment, C/O"}
          value={value.address2 || ""}
          disabled={disabled}
          onChange={(e) => handleChange("address2", e.target.value)}
        />
        <CheckoutInputV2
          label={"City"}
          value={value.city || ""}
          disabled={disabled}
          onChange={(e) => handleChange("city", e.target.value)}
        />
      </InputContainer>
      <InputContainer>
        <CheckoutInputV2
          label={"State"}
          value={value.state || ""}
          disabled={disabled}
          onChange={(e) => handleChange("state", e.target.value)}
        />
        <CheckoutInputV2
          label={"Zip Code"}
          value={value.zipCode || ""}
          disabled={disabled}
          onChange={(e) => handleChange("zipCode", e.target.value)}
        />
      </InputContainer>
    </Container>
  );
};

export default AddressForm;
